import { Modal } from 'antd';
import { ReactNode } from 'react';
import styles from './view-modal.module.css';

interface ViewModalProps {
  isModalOpen: boolean;
  handleCancel: () => void;
  title?: string;
  children?: ReactNode | ReactNode[];
  classNames?: string;
  height?: number;
  width?: number;
}

const classNamesDefault = {
  content: styles['view-modal-content'],
  body: styles['view-modal-body'],
};

const ViewModal: React.FC<ViewModalProps> = ({
  isModalOpen,
  handleCancel,
  children,
  title = 'Request Details',
  height,
  width = 600,
}) => {
  return (
    <Modal
      title={title}
      open={isModalOpen}
      footer={null}
      onCancel={handleCancel}
      width={width}
      classNames={classNamesDefault}
      styles={{ content: { height } }}
    >
      {children}
    </Modal>
  );
};

export default ViewModal;
